export default function FlattenerPricing() {
  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            灵活的定价方案
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            选择适合您业务需求的许可方案，享受专业的PDF表单扁平化服务
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-teal-500 transition-all duration-300">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">内部使用许可</h3>
              <p className="text-gray-600 mb-6">适合企业内部文档处理需求</p>
              <div className="flex items-baseline justify-center gap-2">
                <span className="text-5xl font-bold text-teal-600">¥20,843</span>
                <span className="text-xl text-gray-600">/年</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-teal-600 flex-shrink-0"></i>
                <span className="text-gray-700">支持Windows和Linux平台</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-teal-600 flex-shrink-0"></i>
                <span className="text-gray-700">完整的表单扁平化功能</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-teal-600 flex-shrink-0"></i>
                <span className="text-gray-700">支持所有表单类型</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-teal-600 flex-shrink-0"></i>
                <span className="text-gray-700">命令行批量处理</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-teal-600 flex-shrink-0"></i>
                <span className="text-gray-700">技术支持和文档</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-teal-600 flex-shrink-0"></i>
                <span className="text-gray-700">免费版本升级</span>
              </li>
            </ul>

            <a 
              href="/contact" 
              className="block w-full text-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              免费试用
            </a>
          </div>

          <div className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white rounded-2xl p-8 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/10 rounded-full -ml-16 -mb-16"></div>
            
            <div className="relative">
              <div className="text-center mb-8">
                <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-1 rounded-full text-sm font-semibold mb-4">
                  企业首选
                </div>
                <h3 className="text-2xl font-bold mb-2">OEM许可</h3>
                <p className="text-white/90 mb-6">适合需要再分发的企业和ISV</p>
                <div className="flex items-baseline justify-center gap-2">
                  <span className="text-5xl font-bold">联系销售</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-white flex-shrink-0"></i>
                  <span className="text-white/90">包含内部使用的所有功能</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-white flex-shrink-0"></i>
                  <span className="text-white/90">允许产品再分发</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-white flex-shrink-0"></i>
                  <span className="text-white/90">灵活的许可条款</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-white flex-shrink-0"></i>
                  <span className="text-white/90">优先技术支持</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-white flex-shrink-0"></i>
                  <span className="text-white/90">定制开发服务</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-2xl text-white flex-shrink-0"></i>
                  <span className="text-white/90">专属客户经理</span>
                </li>
              </ul>

              <a 
                href="/contact" 
                className="block w-full text-center bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                联系销售团队
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600">
            所有价格均为人民币，不含税。需要其他货币报价？
            <a href="/contact" className="text-teal-600 hover:text-teal-700 font-semibold ml-1 cursor-pointer">联系我们</a>
          </p>
        </div>
      </div>
    </section>
  );
}
